import type { HTMLAttributes, PropsWithChildren } from "react";
import styles from "./Panel.module.css";

interface PanelProps extends PropsWithChildren, HTMLAttributes<HTMLElement> {
  compact?: boolean;
}

export function Panel({ compact = false, className = "", children, ...props }: PanelProps) {
  return (
    <section {...props} className={`${styles.panel} ${compact ? styles.compact : ""} ${className}`}>
      {children}
    </section>
  );
}
